// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"0bcd20e6","733":"df231585","983":"55162beb"}[chunkId] + ".chunk.js";
};